export const TwoFactorErrorMessages = {
  InvalidAuthenticatorCode:
    'The code you entered is not valid. Please try again.',

  InvalidOrExpiredBackupCode:
    'The backup code you entered is incorrect or has expired. Please try again.',
};

export const getLockoutErrorMessage = (minutesLeft: number) =>
  `You've reached the maximum number of verification attempts. Please try again in ${minutesLeft} ${minutesLeft === 1 ? 'minute' : 'minutes'}.`;
